<template>
  <div class="modal is-active">
    <div class="modal-background" @click="$emit('close-modal')"></div>
    <div class="modal-content">
      <slot></slot>
    </div>
    <button class="modal-close is-large" aria-label="close" @click="$emit('close-modal')"></button>
  </div>
</template>

<script>
  export default {
    name: 'Modal'
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue